<template>
  <div id="app">
    <Sidebar />
    <div
      class="main-container min-w-0 max-lg:ml-0 lg:ml-[var(--sidebar-width)] bg-white"
    >
      <Header />
      <div class="content-container min-w-0 overflow-x-hidden p-4 md:p-6 lg:p-8">
        <router-view />
      </div>
    </div>
    <CustomerService />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useUserStore } from "./stores/user";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar.vue";
import CustomerService from "./components/ui/CustomerService.vue";
import { useLayoutInit } from "./composables/useLayout";

const userStore = useUserStore();
useLayoutInit();

onMounted(async () => {
  try {
    await userStore.ping();

    if (userStore.logined && userStore.userInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userStore.userInfo));
    }
  } catch (error) {
    console.error("用户登录验证失败:", error);
  }
});
</script>
